import React from "react"
import { styled } from "@mui/material/styles"
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import Link from "@mui/material/Link"
import BunnyLogo from "../assets/ratingbunny_core.jpg"  // swap from corpLogo.png

const FullWidthGrid = styled(Grid)(({ theme }) => ({
  width: '100%',
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}))

const CenteredGrid = styled(Grid)(({ theme }) => ({
  width: "95%",
  justifyContent: "center",
  textAlign: "center",
}))

const CenteredRowGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
}))

const BoxPadding = styled(Box)(({ theme }) => ({
  paddingLeft: "15px",
  paddingRight: "15px",
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginBottom: 10,
  textAlign: "left",
  lineHeight: 1.5,
}))

const SectionHeader = styled(Typography)(({ theme }) => ({
  marginBottom: 6,
  marginTop: 18,
  textAlign: "left",
  fontWeight: 600,
}))

const NerdEgg = styled(Link)(({ theme }) => ({
  display: "block",
  textAlign: "right",
  marginTop: 24,
  marginBottom: 4,
  fontSize: "0.75rem",
  color: theme.palette.text.disabled,
  textDecoration: "none",
  opacity: 0.4,
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 1,
    textDecoration: "none",
  },
}))

const AboutInfo = () => {
  return (
    <Grid
      data-test-id='top grid'
      container
      spacing={0}
      marginTop="60px"
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <CenteredGrid item>
        <Box>
          <Paper elevation={4} component={FullWidthGrid}>
            <BoxPadding>

              {/* Header — mirror the nav wordmark: Rating [logo] Bunny */}
              <CenteredRowGrid container>
                <Grid item>
                  <Typography variant="h5">Rating</Typography>
                </Grid>
                <Grid item>
                  <Box
                    component="img"
                    sx={{
                      maxHeight: { xs: 60 },
                      maxWidth: { xs: 60 },
                      mx: 1,
                    }}
                    alt="RatingBunny logo"
                    src={BunnyLogo}
                  />
                </Grid>
                <Grid item>
                  <Typography variant="h5">Bunny</Typography>
                </Grid>
              </CenteredRowGrid>
              <Typography variant="h6" sx={{ textAlign: "center", mt: 1, mb: 1 }}>
                About
              </Typography>

              {/* What it is */}
              <StyledTypography variant="subtitle1" color="primary" paragraph={true}>
                RatingBunny is a free movie discovery tool built for people who'd rather
                search by data than wait for an algorithm to decide what they want to watch.
                Filter across 100+ years of cinema by IMDB rating, genre, type, and performer —
                results display as visual movie posters so browsing feels natural, not like
                reading a spreadsheet. All features are available to every visitor with no
                account required.
              </StyledTypography>

              {/* About the Data */}
              <SectionHeader variant="subtitle1" color="primary">
                About the Data
              </SectionHeader>
              <StyledTypography variant="subtitle1" color="primary" paragraph={true}>
                RatingBunny is powered by IMDB's publicly available non-commercial datasets,
                refreshed daily. This is a passion project operated under IMDB's non-commercial
                use terms — no ads, no subscriptions, no monetization. Just a clean way to find
                something worth watching.
              </StyledTypography>

              {/* About the Builder */}
              <SectionHeader variant="subtitle1" color="primary">
                About the Builder
              </SectionHeader>
              <StyledTypography variant="subtitle1" color="primary" paragraph={true}>
                RatingBunny is built and maintained by Henry Katz, a senior backend engineer
                with 30 years of experience in distributed systems and data platforms. It grew
                out of a personal frustration with recommendation engines and a genuine love
                of film.
              </StyledTypography>

              {/* Contact CTA */}
              <StyledTypography variant="subtitle1" color="primary" paragraph={true}>
                Questions, feedback, or just want to say hi? Head over to the Contact page —
                all messages are welcome.
              </StyledTypography>

              {/* Easter egg — subtle, no label, right-aligned */}
              <NerdEgg href="/nerd" title="For the curious">
                🥚
              </NerdEgg>

            </BoxPadding>
          </Paper>
        </Box>
      </CenteredGrid>
    </Grid>
  )
}

export default AboutInfo
